// Limits for the agenda file the AI-report popover accepts.
//
// Shape copied from src/constants/canmail.js (MAX_ATTACHMENT_SIZE_MB plus a derived _BYTES),
// deliberately NOT imported from it. CANmail's attachment limit and CANmeet's agenda limit are
// two independent product decisions that happen to agree today; a shared import would couple
// them silently, so changing one would move the other.

/**
 * Largest agenda file the popover will accept, in MB.
 *
 * The dropzone's own copy and the oversize message are both derived from this value, so the
 * number appears once.
 */
export const MAX_AGENDA_SIZE_MB = 10;

/**
 * The same limit in bytes. `File.size` is bytes, so this is what the check compares against.
 */
export const MAX_AGENDA_SIZE_BYTES = MAX_AGENDA_SIZE_MB * 1024 * 1024;

/**
 * The accepted agenda extensions, lower-case and dot-prefixed.
 *
 * `.doc` is deliberately absent even though the nearest in-repo allowlist
 * (CANguard's getCheckpointUppyInstance) carries it. The extract endpoint converts `.docx` with
 * mammoth and PDF with pdf-parse; legacy binary `.doc` is neither, so accepting it here would
 * produce a client-side pass followed by a server-side rejection.
 *
 * The extension test is the client's share of the work only. Browsers report an unreliable MIME
 * type for Office files, so the extract endpoint's own rejection is the real gate and the popover
 * renders it in the same inline Alert.
 */
export const ACCEPTED_AGENDA_EXTENSIONS = [".docx", ".pdf", ".txt"] as const;

/**
 * The `accept` attribute for the hidden file input, built from the list above.
 */
export const ACCEPTED_AGENDA_ATTRIBUTE = ACCEPTED_AGENDA_EXTENSIONS.join(",");

/**
 * Popover width in px. The `calc(100vw - 32px)` guard beside it in the component is what keeps
 * this width mobile-safe.
 */
export const AGENDA_POPOVER_WIDTH_PX = 432;
